.heading {
  font-weight: bold;
  margin: var(--ns-space-2) var(--ns-space-1) var(--ns-space-2) 0;
  color: var(--ns-color-black);
}